import React from "react";
import { Link } from "gatsby";

import SEO from "../components/seo";

import "../styles/tailwind.css";
import Navbar from "../components/Navbar";

const IndexPage: React.FC = () => (
  <div>
    <SEO title="Home" />
    <Navbar />
    <div className="flex flex-col p-4">
      <div>Env to strapi URL {process.env.GATSBY_STRAPI_URL} </div>
      <Link to="/booking">Go to Booking</Link>
      <Link to="/albums">Go to Albums</Link>
    </div>
  </div>
);

export default IndexPage;
